<template>
  <div
    class="flex items-start justify-start text-sm text-ocean-100"
    :class="[isStacked ? 'flex-col space-y-4' : 'flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6']"
  >
    <div
      v-if="author"
      class="flex items-center"
    >
      <vetster-circle-avatar :author="author" />
      <div class="md:mr-6">
        <div class="whitespace-nowrap theme-text-neutral">
          {{ $t('symptoms-and-conditions.researched-by') }}
        </div>
        <a
          :href="getAuthorUrl(author)"
          class="font-semibold hover:underline transition theme-text-main"
        >
          {{ author.name }}
        </a>
        <fa
          v-if="author.is_editorial_team"
          :icon="['fas', 'badge-check']"
          class="text-base text-bubblegum inline-flex ml-0.5 items-center"
        />
      </div>
    </div>

    <div
      v-if="verifiedAuthor"
      class="flex items-center justify-start"
    >
      <vetster-circle-avatar :author="verifiedAuthor" />
      <div>
        <div class="whitespace-nowrap theme-text-neutral">
          {{ $t('symptoms-and-conditions.verified-by') }}
        </div>
        <a
          :href="getAuthorUrl(verifiedAuthor)"
          class="font-semibold hover:underline transition theme-text-main"
        >
          {{ verifiedAuthor.name }}
        </a>
        <fa
          v-if="verifiedAuthor.is_editorial_team"
          :icon="['fas', 'badge-check']"
          class="text-base text-bubblegum inline-flex ml-0.5 items-center"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VetsterCircleAvatar from '@/brand-components/Content/VetsterCircleAvatar';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterAuthorGroup',

  components: { VetsterCircleAvatar },

  mixins: [LocalizesRoutes],

  props: {
    author: {
      type: Object,
      default: () => ({}),
    },
    isStacked: {
      type: Boolean,
      default: true,
    },
    verifiedAuthor: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    getAuthorUrl(author) {
      if (author.is_partner) {
        return author.url_website;
      }

      return this.localizeLanguageUrl(`/author/${author.slug}`);
    },
  },
};
</script>
